module.exports = __webpack_public_path__ + "static/img/1.2a93c59.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/eng/1.png
// module id = kjaz
// module chunks = 0